import { makeAutoObservable } from "mobx";
export interface EpicType {
	id: number;
	name: string;
	isActive: boolean;
}

export class EpicTypeModel implements EpicType {
	readonly id: number;
	name: string;
	isActive: boolean = true;

	constructor(epicType: EpicType) {
		makeAutoObservable(this);
		this.id = epicType.id;
		this.name = epicType.name;
		this.isActive = epicType.isActive ?? true;
	}
	get canSave() {
		return Boolean(this.name.trim());
	}
	setName(name: string) {
		this.name = name;
	}
}